// TODO: move to separate api utils file with SOSHDL-863

export const logError = async (
    formName: string,
    error: string,
    type: 'submit' | 'validation',
    details?: Record<string, any>
) => {
    try {
        await fetch('/api/raeLogError', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                formName,
                error,
                type,
                details,
            }),
        });
    } catch (loggingError) {
        console.error(`Failed to log ${type} error:`, loggingError);
    }
};
